// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.project-detail .nav {
  padding: 9px 40px 0px 40px;
  border-bottom: 2px solid #d4d4d4;
  gap: 50px;
}
.project-detail .nav-underline .nav-link {
  margin-bottom: -2px;
}
.project-detail .nav-underline .nav-link.active,
.project-detail .nav-underline .show > .nav-link {
  border-width: 4px;
  border-color: #333333;
}
.project-detail .nav-link:hover,
.project-detail .nav-link:focus {
  border-width: 4px;
  color: #333333;
}
.project-detail .nav-link {
  color: #3f3f46;
  font-weight: bold;
}`, "",{"version":3,"sources":["webpack://./packages/dre-magi-translate/frontend/src/pages/admin/project/item/index.scss"],"names":[],"mappings":"AACE;EACE,0BAAA;EACA,gCAAA;EACA,SAAA;AAAJ;AAGE;EACE,mBAAA;AADJ;AAIE;;EAEE,iBAAA;EACA,qBAAA;AAFJ;AAKE;;EAEE,iBAAA;EACA,cAAA;AAHJ;AAME;EACE,cAAA;EACA,iBAAA;AAJJ","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
